import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { GiBlackBelt } from "react-icons/gi";

import {
  formatGradeDate,
  getBeltImage,
  getBeltName,
} from "../utils/passageGradeUtils";

function BeltHistoryTimeline({
  grades,
  deletingIds = [],
  onEdit,
  onDelete,
}) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-6">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-orange-600 dark:text-orange-200">
            Historique
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Passages de grades
          </h2>
        </div>

        <p className="text-sm font-medium text-slate-500 dark:text-white/50">
          {grades.length} passage{grades.length > 1 ? "s" : ""} enregistré
          {grades.length > 1 ? "s" : ""}
        </p>
      </div>

      {grades.length === 0 ? (
        <div className="mt-6 rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 p-8 text-center dark:border-white/10 dark:bg-white/[0.03]">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-slate-500 shadow-sm dark:bg-white/10 dark:text-white/50">
            <GiBlackBelt className="text-2xl" />
          </div>

          <p className="mt-4 text-sm font-bold text-slate-700 dark:text-white">
            Aucun passage de grade enregistré.
          </p>

          <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
            Ajoute une ceinture pour créer l'historique du judoka.
          </p>
        </div>
      ) : (
        <div className="mt-6 space-y-4">
          {grades.map((grade, index) => {
            const beltImage = getBeltImage(grade);
            const isLast = index === 0;
            const isDeleting = deletingIds.includes(grade.id);

            return (
              <article
                key={grade.id}
                className="relative rounded-[1.75rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.04]"
              >
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
                  <div className="flex h-20 w-full items-center justify-center rounded-[1.5rem] bg-white shadow-sm dark:bg-slate-950 sm:w-32">
                    {beltImage ? (
                      <img
                        src={beltImage}
                        alt={getBeltName(grade)}
                        className="h-16 w-full object-contain"
                      />
                    ) : (
                      <GiBlackBelt className="text-3xl text-slate-400" />
                    )}
                  </div>

                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      {isLast && (
                        <span className="rounded-full bg-orange-100 px-3 py-1 text-xs font-bold text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
                          Ceinture actuelle
                        </span>
                      )}

                      <span className="rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-500 shadow-sm dark:bg-white/10 dark:text-white/50">
                        {formatGradeDate(grade.date_passage)}
                      </span>
                    </div>

                    <h3 className="mt-3 font-titre text-2xl font-bold text-slate-950 dark:text-white">
                      {getBeltName(grade)}
                    </h3>
                  </div>

                  <div className="grid gap-2 sm:w-36">
                    <button
                      type="button"
                      onClick={() => onEdit(grade)}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-sky-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5"
                    >
                      <FaEdit />
                      Modifier
                    </button>

                    <button
                      type="button"
                      onClick={() => onDelete(grade)}
                      disabled={isDeleting}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                    >
                      <FaTrash />
                      {isDeleting ? "Suppression..." : "Supprimer"}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default BeltHistoryTimeline;